import Storage from "@/commons/storage";
import Request from "@/commons/request";
import Message from "@/components/message";

function toPage(app) {
    console.log(app);
    let uri = app.puri
    if (uri == '#') {
        Message.toast("项目开发中，尽请期待！", { color: "error" });
        return
    }
    Request.postForm("/view/users/authorize", { aid: app.aid || app.id }).then((res) => {
        if (res.data) {
            let links = uri + (uri.includes('?') ? "&stoken=" : "?stoken=") + Storage.get("_wit_acis_token");
            window.open(links, '_blank');
        } else {
            Message.toast("对不起，您没有相关系统权限，请申请对应企业资质后再使用！", { color: "error" });
        }
    });
}
export default toPage;